var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlagLightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.049 36.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #6089bd;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_1059091_cc",
    transform: "translate(-25.84 -20.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(26.84 21.86)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    className: "cls-1",
    x1: 13.762,
    y2: 34.063,
    transform: "translate(13.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    className: "cls-1",
    d: "M54.038,40.656H42.61L48.937,25H60.26",
    transform: "translate(-33.363 -23.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "cls-1",
    d: "M41.019,30.62H33.167L26.84,46.276H40.2l-4.116-3.3",
    transform: "translate(-26.84 -25.483)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    className: "cls-1",
    x1: 1.331,
    y2: 3.29,
    transform: "translate(13.369 17.503)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagLightBlue);
export default __webpack_public_path__ + "static/media/icon-flag-light-blue.a0b2efa0c8a905f5d121eca77ba1a24e.svg";
export { ForwardRef as ReactComponent };